import { ReactNode } from "react";
import {
  OverlayProps as ReactOverlayProps,
  Overlay as ReactOverlay,
} from "react-bootstrap";

import styles from "./Overlay.module.scss";

interface OverlayProps extends Omit<ReactOverlayProps, "children"> {
  children: ReactNode;
}

export const Overlay = ({ target, show, children, ...props }: OverlayProps) => {
  return (
    <ReactOverlay target={target} show={show} {...props}>
      {({ ...props }) => (
        <div {...props} className={styles.overlay}>
          {children}
        </div>
      )}
    </ReactOverlay>
  );
};
